var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-carousel',{attrs:{"cycle":"","width":"100%","show-arrows-on-hover":"","hide-delimiters":""}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item.src}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }